

import React, { useEffect, useState } from "react";
import { Card, Col, Form, Row } from "antd";
import { Link, useNavigate } from "react-router-dom";

import { getDropDownMaster } from "../../../services/customerFutures";
import { routes } from "../../../routes";
import WithSidebar from "../../../templates/withSidebar";
import Heading from "../../../components/common/heading";

export const SelectChannelAddFutureCustomer = () => {
  const [channel, setChannel] = useState([]);
  const navigate = useNavigate(); 
  useEffect(() => {
    const loadChannel = async () => {
      try {
        const res = await getDropDownMaster("known_channel");

        if (res?.data?.code === "0000") {
          setChannel(res.data.objectValue || []);
        } else {
          setChannel([]);
        }
      } catch (error) {
        console.error("loadChannel error :", error);
        setChannel([]);
      }
    };

    loadChannel();
  }, []);

  
  return (
    <WithSidebar>
      <Card style={{ width: "80%" }}>
        <Form.Item name="card_answer">
          <Heading
            text="เลือก ช่องทางเข้ามาติดต่อ"
            size={4}
            style={{ margin: "0px 0px 10px 0px" }}
          />

          {channel.map((item) => (
            <Row key={item.dataId} style={{ paddingBottom: 10 }}>
              <Col span={18}>
                <Link
                  to={routes.add_customer_future}
                  state={{
                    id: 1,
                    action_type: "CREATE",
                    channel: item.dataId,
                  }}
                >
                  {item.dataDetailTh}
                </Link>
              </Col>
            </Row>
          ))}

          {channel.length === 0 && (
            <Row>
              <Col span={24} style={{ color: "#999" }}>
                ไม่พบข้อมูลช่องทาง
              </Col>
            </Row>
          )}
        </Form.Item>
      </Card>
    </WithSidebar>
  );
};

export default SelectChannelAddFutureCustomer;
